<template>
  <v-dialog
    v-model="dialog"
    width="80%"
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Select a school
      </v-card-title>

      <v-card-text>
        <SchoolSearchInput/>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="redirect()"
        >
          Select
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import SchoolSearchInput from "./SchoolSearchInput";

  export default {
    name: "SchoolsSelector",
    components: {
      SchoolSearchInput,
    },
    data() {
      return {dialog: true,};
    },
    methods: {
      redirect() {
      }
    }
  }
</script>

<style scoped>
  .v-card__title {
    color: white;
    background-color: #041E42 !important;
  }
</style>
